<template>
  <div id="app">
    <app-header></app-header>
    <app-nav></app-nav>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader/AppHeader.vue";
import AppFooter from "./components/AppFooter/AppFooter.vue";
import AppNav from './components/AppNav/AppNav.vue';
export default {
  components: { AppHeader, AppFooter, AppNav },
  data () {
    return {};
  },
  computed: {

  },
  mounted () { },
  methods: {},
};
</script>

<style lang="scss">
* {
  font-family: Microsoft YaHei;
}
#app {
  max-width: 1920px;
  margin: 0 auto;
}
img {
  -webkit-user-drag: none;
}
.nws-con {
  img {
    max-width: 100%;
  }
}
</style>
